import { typography } from '@gto/ui/typography'

import { popupRowStyles } from './row-styles'

export const listboxStyles = {
  positioner: 'z-popover',
  // Surface matched to the Menu popup (`ui/menu/popup.tsx`): same elevation,
  // radius, `shadow-8` and the same open/close transition, so a Select or
  // Autocomplete dropdown reads as the same floating surface as a Menu rather
  // than a second one that appears instantly. Base UI's Positioner sets
  // `--transform-origin`, so the popup scales out of the trigger corner.
  //
  // `overflow-hidden` lets the radius clip the scrolling list inside.
  //
  // NOT copied from Menu: its `p-1` and `gap-[1px]`. Menu items are direct
  // children of its popup; a listbox nests a scrollable `list` between the two,
  // which already carries that padding and gap. Adding them here would double it.
  popup: [
    'bg-paper-elevation4 shadow-8 z-popover relative overflow-hidden rounded-sm outline-none',
    'w-[var(--anchor-width)] max-w-[var(--available-width)]',
    'origin-[var(--transform-origin)] transition duration-150 ease-out',
    'data-[starting-style]:scale-95 data-[starting-style]:opacity-0',
    'data-[ending-style]:scale-95 data-[ending-style]:opacity-0',
  ],
  list: [
    'gap-0.5 flex flex-col items-start self-stretch p-1 overflow-y-auto',
    'max-h-[min(var(--available-height),23rem)] w-full max-w-[var(--available-width)]',
  ],
  group: 'w-full pb-0.5 last:pb-0 gap-0.5 flex flex-col',
  groupLabel: [typography['body4/cap'], 'text-text-action-active px-1 h-5 flex items-center'],
  item: popupRowStyles,
}
